import FormProvider, { RHFTextField } from '@commons/hook-form';
import { Stack } from '@mui/material';
import { Button } from '@PorkyCol/button';
import {
  CustomerForm,
  useCreateCustomerForm,
} from '@modules/customer/hooks/use-create-customer-form';
import { useForm } from 'react-hook-form';
import { useCustomerCommons } from '@hooks/use-customer-commons';
import Loader from '@commons/loader';
import RHFAutocomplete2 from '@commons/hook-form/RHFAutocomplete2';
import { useEffect } from 'react';

export const CreateCustomerForm = ({ callback, inputValue }: any) => {
  const methods = useForm<CustomerForm>({});
  const { data, isLoading } = useCustomerCommons();
  const { submit, isValid, isSubmitting } = useCreateCustomerForm(methods, callback);

  useEffect(() => {
    methods.setValue('name', inputValue)
  }, [inputValue, methods])

  if (isLoading) return <Loader />;
  return (
    <FormProvider methods={methods} onSubmit={submit}>
      <Stack flexDirection="column" gap={3}>
        <Stack gap={2}>
          <RHFTextField name="name" size="medium" label="Nombre" fullWidth />
          <RHFTextField name="email" size="medium" label="Email" fullWidth />
          <RHFAutocomplete2
            name="type_document_identification_id"
            size="md"
            label="Documento de identificación"
            options={data?.typeDocumentIdentification?.select ?? []}
            fullWidth
          />
          <RHFTextField
            name="identification_number"
            size="medium"
            label="Numero de identificación"
            type="number"
            fullWidth
          />
          <RHFTextField name="address" size="medium" label="Dirección" fullWidth />
          <RHFTextField name="phone" size="medium" label="Telefono" fullWidth />
          <RHFAutocomplete2
            name="type_organization_id"
            size="md"
            label="Tipo de organización"
            options={data?.typeOrganization?.select ?? []}
            fullWidth
          />
          <RHFAutocomplete2
            name="type_regime_id"
            size="md"
            label="Regimen"
            options={data?.typeRegime?.select ?? []}
            fullWidth
          />
          <RHFAutocomplete2
            name="municipality_id"
            size="md"
            label="Municipio"
            options={data?.municipality ?? []}
            fullWidth
          />
        </Stack>
        <Stack flexDirection="row" gap={2} justifyContent="flex-end">
          <Button
            onClick={callback}
            color="primary"
            className="bg-primary-700 border-primary-700 hover:bg-primary-600 hover:border-primary-600 focus:ring-primary-300 focus:border-primary-200"
            type="button"
            variant="solid"
          >
            Cancelar
          </Button>
          <Button
            disabled={!isValid}
            color="primary"
            type="submit"
            variant="solid"
            loading={isSubmitting}
          >
            Guardar
          </Button>
        </Stack>
      </Stack>
    </FormProvider>
  );
};
